import Toggle from "../../components/Toggle/Toggle";
import TableButton from '../../components/Table/TableButton/TableButton';
import { FaPen ,FaTrashAlt } from 'react-icons/fa';

export const materialTableColumns = (openModal, clickDelete, update ) => [
  { header: '자재명', accessor: 'materialName' },
  { header: '규격', accessor: 'specification' },
  { header: '자재코드', accessor: 'materialCode' },
  { header: '단위', accessor: 'stockUnitCode' },
  { header: '평균단가', accessor: 'averagePrice', render: (row) => `${row.averagePrice.toLocaleString()} 원` },
  { header: '잔량', accessor: 'amount', render: (row) => {
      if (row.useSafetyStock && row.amount <= row.safetyStockAmount) {
        return <span
          style={{
            color: 'red',
          }}
        >
          {row.amount.toLocaleString()}
        </span>;
      } else{
        return row.amount.toLocaleString();
      }
    }
  },
  { header: '평균사용량', accessor: 'averageUsage' },
  { header: '안전 재고', accessor: 'safetyStockAmount' },
  { header: '안전 재고 사용', accessor: 'useSafetyStock', render: (row) => (
      <Toggle 
        isOn={row.useSafetyStock}
        handleToggle={(e)=>{ e.stopPropagation(); update({materialSeq : row.materialSeq, useSafetyStock : !row.useSafetyStock});}}
        onText="사용"
        offText="미사용"
      />
    )
  },
  { header: '재고관리 사용', accessor: 'useStockManagement', render: (row) => (
    <Toggle 
      isOn={row.useStockManagement}
      handleToggle={(e)=>{ e.stopPropagation(); update({materialSeq : row.materialSeq, useStockManagement : !row.useStockManagement});}}
      onText="사용"
      offText="미사용"
    />
    )
  },
  // { header: '상세보기', accessor: 'details', render: (row) => (
  //   <TableButton text="상세보기" onClick={() => handleInventoryClick(row)} className="detail-view"/>
  // )},
  { header: '수정', accessor: 'attachments', render: (row) =>
    <span onClick={(e) =>{ e.stopPropagation(); openModal(2, 1, row) }} style={{ cursor: 'pointer' }}><FaPen/></span>
  },
  { header: '삭제', accessor: 'delete', render: (row) =>
    <span onClick={(e) => { e.stopPropagation(); clickDelete(row) }} style={{ cursor: 'pointer' }}><FaTrashAlt/></span>
  },
];

export const materialSearchFormFields = [
  { key: "materialName", label: "자재명", type: "text", size: 6, visible: true },
  { key: "materialCode", label: "자재 코드", type: "text", size: 6, visible: true },
  { key: "amount", label: "수량", type: "number", size: 6, visible: true },
  { key: "warming", label: "잔량 경고", type: "checkbox", onText: "위험", offText: "전부", size: 6, visible: true , default: true},
  { key: "useSafetyStock", label: "안전재고 사용", type: "checkbox", onText: "사용", offText: "미사용", size: 6, visible: true, default: true},
  { key: "useStockManagement", label: "재고관리 사용", type: "checkbox", onText: "사용", offText: "미사용", size: 6, visible: true, default: true},
];

export const materialFormFields = [
  { key: "materialSeq", label: "자재번호", type: "text", size: 6, visible: false, required: false },
  { key: "companySeq", label: "회사번호", type: "text", size: 6, visible: false, required: false },
  { key: "materialName", label: "자재명", type: "text", size: 6, visible: true, required: true },
  { key: "specification", label: "규격", type: "text", size: 6, visible: true, required: true },
  { key: "materialCode", label: "자재 코드", type: "text", size: 6, visible: true, required: true },
  { key: "stockUnitCode", label: "단위", type: "text", size: 6, visible: true, required: true },
  { key: "safetyStockAmount", label: "안전 재고 수량", type: "number", size: 6, visible: true, required: true },
  { key: "useSafetyStock", label: "안전 재고사용", type: "checkbox", onText: "사용", offText: "미사용", size: 6, visible: true, default: false },
  { key: "useStockManagement", label: "재고관리 사용", type: "checkbox", onText: "사용", offText: "미사용", size: 6, visible: true, default: false },
];

export const materialInColumns =  (openModal, clickDelete ) => [
  { header: '입고일', accessor: 'warehousingDt' },
  { header: '입고처', accessor: 'partnerName' },
  { header: '수량', accessor: 'quantity' },
  { header: '매입가', accessor: 'price', render: (row) => `${row.price.toLocaleString()} 원` },
  { header: '단가', accessor: 'pricePerUnit', render: (row) => `${row.pricePerUnit.toLocaleString()} 원` },
  { header: '수정', accessor: 'attachments', render: (row) =>
    <span onClick={(e) => {e.stopPropagation(); openModal(2, 2, row) }} style={{ cursor: 'pointer' }}><FaPen/></span>
  },
  { header: '삭제', accessor: 'delete', render: (row) =>
    <span onClick={(e) => {e.stopPropagation(); clickDelete(row) }} style={{ cursor: 'pointer' }}><FaTrashAlt/></span>
  },
];

export const materialInFormFields =  [
  { key: "materialInSeq", label: "공정번호", type: "text", size: 6, visible: false, required: false },
  { key: "materialSeq", label: "공정번호", type: "text", size: 6, visible: false, required: false },
  { key: "companySeq", label: "회사번호", type: "text", size: 6, visible: false, required: false },
  { key: "warehousingDt", label: "입고일", type: "date", size: 6, visible: true, required: true },
  { key: "partnerSeq", label: "입고처", type: "apiSelect", apiKey: 'partner',  labelKey: "partnerName", valueKey: "partnerSeq", size: 6, visible: true, required: true },
  { key: "quantity", label: "수량", type: "number", size: 6, visible: true, required: true },
  { key: "price", label: "매입가", type: "number", visible: true, required : true },
];

export const materialOutColumns =  (openModal, clickDelete ) => [
  { header: '출고일', accessor: 'forwardingDt' },
  { header: '수주번호', accessor: 'contractNum' },
  { header: '출고자', accessor: 'userName' },
  { header: '수량', accessor: 'quantity' },
  { header: '사용부서', accessor: 'department' },
  { header: '수정', accessor: 'attachments', render: (row) =>
    <span onClick={(e) => {e.stopPropagation(); openModal(2, 3, row)}} style={{ cursor: 'pointer' }}><FaPen/></span>
  },
  { header: '삭제', accessor: 'delete', render: (row) =>
    <span onClick={(e) => {e.stopPropagation(); clickDelete(row)}} style={{ cursor: 'pointer' }}><FaTrashAlt/></span>
  },
];
export const materialOutFormFields = [
  { key: "materialOutSeq", label: "출고번호", type: "text", size: 6, visible: false, required: false },
  { key: "materialSeq", label: "자재번호", type: "text", size: 6, visible: false, required: false },
  { key: "companySeq", label: "회사번호", type: "text", size: 6, visible: false, required: false },
  { key: "forwardingDt", label: "출고일", type: "date", size: 6, visible: true, required: true },
  { key: "contractSeq", label: "수주 번호", type: "apiSelect", apiKey: 'contract',  labelKey: "contractNum", valueKey: "contractSeq", size: 6, visible: true, required: true },
  { key: "userSeq", label: "출고자", type: "apiSelect", apiKey: 'user',  labelKey: "userName", valueKey: "userSeq", size: 6, visible: true, required: true },
  { key: "quantity", label: "수량", type: "number", size: 6, visible: true, required: true },
];